import {
  FORMAT_MAPPING_TRANSLATION_COLUMN as FORMAT_MAPPING_TRANSLATION_COLUMN_TABLE_KEY_VALUE,
  FORMAT_PERIOD_DATE_COLUMN,
} from '../../../components/table/TableKeyValuePureMarkup/TableKeyValuePureMarkup';
import {
  FORMAT_COMMON_COLUMN,
  FORMAT_CURRENCY_AUTO_COMMA_COLUMN,
  FORMAT_DATE_COLUMN,
  FORMAT_MAPPING_TRANSLATION_COLUMN,
} from '../../../components/table-row/TableRowPureMarkup/TableRowPureMarkup';
import { mappingSalesQuotationStatus } from '../label-value/sales-status';

// column sales quotation list that handling table head with translation
export const columnsTableHeaderSalesQuotation = (t) => {
  return [
    {
      name: 'transaction_date',
      name_input: 'from_date',
      label: t('dashboard.sales.sales-quotation.table.header-column.transaction-date'),
      placeholder: t('dashboard.sales.sales-quotation.input.search-transaction-date.placeholder'),
      width: 200,
    },
    {
      name: 'transaction_no',
      name_input: 'transaction_no',
      label: t('dashboard.sales.sales-quotation.table.header-column.transaction-no'),
      placeholder: t('dashboard.sales.sales-quotation.input.search-transaction-no.placeholder'),
      width: 200,
    },
    {
      name: 'customer_name',
      name_input: 'customer_name',
      label: t('dashboard.sales.sales-quotation.table.header-column.customer'),
      placeholder: t('dashboard.sales.sales-quotation.input.search-customer.placeholder'),
      width: 400,
      align: 'left',
    },
    {
      name: 'amount',
      label: t('dashboard.sales.sales-quotation.table.header-column.nominal'),
      align: 'right',
      width: 150,
    },
    {
      name: 'status',
      name_input: 'status',
      label: t('dashboard.sales.sales-quotation.table.header-column.status'),
      placeholder: t('dashboard.sales.sales-quotation.select.search-status.placeholder'),
      align: 'left',
      width: 150,
      maxWidth: 155,
    },
  ];
};

export const columnsTableHeaderSalesQuotationPDFprint = (t) => {
  return [
    {
      name: 'transaction_date',
      label: t('dashboard.sales.sales-quotation.table.header-column.transaction-date'),
      style: {
        width: 200,
        position: 'unset',
      },
      formatData: FORMAT_DATE_COLUMN,
    },
    {
      name: 'transaction_no',
      label: t('dashboard.sales.sales-quotation.table.header-column.transaction-no'),
      style: {
        width: 200,
        position: 'unset',
      },
      formatData: FORMAT_COMMON_COLUMN,
    },
    {
      name: 'customer_name',
      label: t('dashboard.sales.sales-quotation.table.header-column.customer'),
      style: {
        width: 400,
        position: 'unset',
      },
      formatData: FORMAT_COMMON_COLUMN,
    },
    {
      name: 'amount',
      label: t('dashboard.sales.sales-quotation.table.header-column.nominal'),
      style: {
        width: 150,
        position: 'unset',
      },
      formatData: FORMAT_CURRENCY_AUTO_COMMA_COLUMN,
      isUseZeroNumberWhenNull: true,
      align: 'right',
    },
    {
      name: 'status',
      label: t('dashboard.sales.sales-quotation.table.header-column.status'),
      style: {
        width: 150,
        maxWidth: 155,
        position: 'unset',
      },
      formatData: FORMAT_MAPPING_TRANSLATION_COLUMN,
      mappingTranslation: mappingSalesQuotationStatus,
    },
  ];
};

// columns key value table
export const columnsTableKeyValuePrintIndexSalesQuotation = [
  {
    header: 'dashboard.sales.sales-quotation.table.header-column.transaction-date',
    valueKeyName: 'search_from_date',
    valueKeyNameSecondary: 'search_to_date',
    formatValue: FORMAT_PERIOD_DATE_COLUMN,
    showOnlyWhenExistedValue: true,
  },
  {
    header: 'dashboard.sales.sales-quotation.table.header-column.transaction-no',
    valueKeyName: 'search_transaction_no',
    showOnlyWhenExistedValue: true,
  },
  {
    header: 'dashboard.sales.sales-quotation.table.header-column.customer',
    valueKeyName: 'search_customer_name',
    showOnlyWhenExistedValue: true,
  },
  {
    header: 'dashboard.sales.sales-quotation.table.header-column.status',
    valueKeyName: 'search_status',
    formatValue: FORMAT_MAPPING_TRANSLATION_COLUMN_TABLE_KEY_VALUE,
    mappingTranslation: mappingSalesQuotationStatus,
    showOnlyWhenExistedValue: true,
  },
];

export const columnsSearchWithDate = ['from_date', 'to_date'];

// column that representation for calculation
export const calculationColumns = ['amount'];
